import { render } from "./ObjectSettings.vue?vue&type=template&id=e2f105d8"
import script from "./ObjectSettings.vue?vue&type=script&lang=js"
export * from "./ObjectSettings.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/origina/V3/v2026.27.r2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__